import {Main} from '../../components/main/main.tsx';
import {Page} from '../../components/page/page.tsx';
import {PageContent} from '../../components/page/page_content.tsx';
import {PageTitle} from '../../components/page/page_title.tsx';
import {PageIcon} from '../../components/page/page_icon.tsx';
import {__} from '../../support/lang/translations.ts';
import {useNavigate} from 'react-router-dom';

export function AppointmentSuccess() {
    const navigate = useNavigate();

    window.setTimeout(() => navigate('/'), 2500);

    return (
        <Main>
            <Page>
                <PageIcon>
                    <i className="fa-light fa-check" />
                </PageIcon>
                <PageTitle>
                    <h1>{__('appointment.success.title')}</h1>
                </PageTitle>
                <PageContent>
                    <h3 style={{maxWidth: 450, margin: 'auto', textAlign: 'center'}}>
                        {__('appointment.success.message')}
                    </h3>
                </PageContent>
                <PageContent>
                    <p style={{maxWidth: 450, margin: 'auto', textAlign: 'center'}}>
                        {__('appointment.success.redirect')}
                    </p>
                </PageContent>
            </Page>
        </Main>
    );
}
